<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','width','data'],
  methods: {
    newData: function() {
      this.renderChart({
        datasets: [{
          data: this.xy,
          label: "Jours d'inactivité",
          borderColor: "rgba(255,152,111,0.6)",
          backgroundColor: "rgba(255,152,111,0.2)"
        }]},
        {
          title: {
            display: true,
            fontSize: 20,
            text: 'Inactivité des plans en développement'
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Nombre'
              },
              ticks: {min: 0, suggestedMax: 20 },
              // stacked: true,
            }],
            xAxes: [{
              ticks: {
                min: 0, //minimum tick
                max: 400, //maximum tick
                callback: function (value) {
                    return value + ' jours';
                }
              },
              type: 'logarithmic'
            }
          ]},
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    // datasets
    xy() {
      return this.data.map(x => ({x: x.age_en_jours, y: x.total})).reverse();
    }
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
